<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.48,4C11.48,4,12.59,4,12.59,4C12.59,4,12.3,4.29,12.3,4.29C12.11,4.47,12,4.72,12,5C12,5.55,12.45,6,13,6C13.28,6,13.53,5.89,13.71,5.71C13.71,5.71,15.71,3.71,15.71,3.71C15.89,3.53,16,3.28,16,3C16,2.72,15.89,2.47,15.71,2.29C15.71,2.29,13.71,0.29,13.71,0.29C13.53,0.11,13.28,0,13,0C12.45,0,12,0.45,12,1C12,1.28,12.11,1.53,12.29,1.71C12.29,1.71,12.59,2,12.59,2C12.59,2,11,2,11,2C10.68,2,10.41,2.16,10.23,2.38C10.23,2.38,10.22,2.37,10.22,2.37C10.22,2.37,8.28,4.8,8.28,4.8C8.28,4.8,9.56,6.4,9.56,6.4C9.56,6.4,11.48,4,11.48,4C11.48,4,11.48,4,11.48,4ZM13.71,10.29C13.53,10.11,13.28,10,13,10C12.45,10,12,10.45,12,11C12,11.28,12.11,11.53,12.29,11.71C12.29,11.71,12.59,12,12.59,12C12.59,12,11.48,12,11.48,12C11.48,12,3.78,2.38,3.78,2.38C3.78,2.38,3.77,2.38,3.77,2.38C3.59,2.16,3.32,2,3,2C3,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3.55,0.45,4,1,4C1,4,2.52,4,2.52,4C2.52,4,10.22,13.62,10.22,13.62C10.22,13.62,10.23,13.61,10.23,13.61C10.41,13.84,10.68,14,11,14C11,14,12.59,14,12.59,14C12.59,14,12.3,14.29,12.3,14.29C12.11,14.47,12,14.72,12,15C12,15.55,12.45,16,13,16C13.28,16,13.53,15.89,13.71,15.71C13.71,15.71,15.71,13.71,15.71,13.71C15.89,13.53,16,13.28,16,13C16,12.72,15.89,12.47,15.71,12.29C15.71,12.29,13.71,10.29,13.71,10.29C13.71,10.29,13.71,10.29,13.71,10.29ZM2.52,12C2.52,12,1,12,1,12C0.45,12,0,12.45,0,13C0,13.55,0.45,14,1,14C1,14,3,14,3,14C3.32,14,3.59,13.84,3.77,13.62C3.77,13.62,3.78,13.63,3.78,13.63C3.78,13.63,5.72,11.21,5.72,11.21C5.72,11.21,4.44,9.6,4.44,9.6C4.44,9.6,2.52,12,2.52,12C2.52,12,2.52,12,2.52,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Random',
} as DefineComponent
</script>
